<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let contactPostId: string | null = null;
  /** Hide for signedContact preview (already-signed docs are read-only) */
  export let showSignButton = true;
  /** Show Download in place of Sign Document for signedContact preview */
  export let showDownloadButton = false;
  export let downloading = false;
</script>

<div
  class="sign-preview-header fixed z-10 top-0 left-0 right-0 flex justify-center items-center bg-gray-200 border-b border-gray-300"
>
  <button
    class="flex items-center px-3 py-2 bg-gray-400 rounded-md hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-500"
    on:click={() => dispatch('back')}
  >
    <img src="arrow_back.svg" alt="Back" class="w-5 h-5 mr-2" />
    Back
  </button>
  {#if showSignButton}
    <button
      class="flex items-center px-3 py-2 ml-3 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
      on:click={() => dispatch('sign')}
    >
      <img src="sign_preview.svg" alt="Sign Document" class="w-5 h-5 mr-2" />
      <span class="sign-preview-header__label">Sign Document</span>
    </button>
  {:else if showDownloadButton}
    <button
      class="flex items-center px-3 py-2 ml-3 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
      class:opacity-60={downloading}
      class:cursor-not-allowed={downloading}
      disabled={downloading}
      data-testid="signed-preview-download-button"
      on:click={() => dispatch('download')}
    >
      <img src="download.svg" alt="Download" class="w-5 h-5 mr-2" />
      <span class="sign-preview-header__label">{downloading ? 'Downloading' : 'Download'}</span>
    </button>
  {/if}
</div>

<style>
  .sign-preview-header {
    height: 4rem;
    gap: 0.5rem;
    padding: 0 0.75rem;
  }

  @media (max-width: 767px) {
    .sign-preview-header {
      height: 3.5rem;
      padding: 0 0.5rem;
    }

    .sign-preview-header button {
      font-size: 0.875rem;
    }

    .sign-preview-header__label {
      display: none;
    }
  }
</style>
